import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from './http-utils.service';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, mergeMap } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { User, UserData, UserListData } from '../../models/user';
import { Paging } from '../../models/paging';

@Injectable({
	providedIn: 'root'
})
export class UsersService {
	private _url: string = `${environment.baseAPI}/users`;

	constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) { }

	GETUsers(paging:Paging){
		try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}${paging.getQs()}`, { headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: UserListData = jsonConvert.deserializeObject(res, UserListData);
                            if (response.success) {
                            	return response;
                            } else {
                            	this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
	}

	GETUser(user_uuid: string): Observable<User>{
		try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/${user_uuid}`, { headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: UserData = jsonConvert.deserializeObject(res, UserData);
                            if (response.success) {
                            	return response.data;
                            } else {
                            	this._httpUtils.handleError(response);
                                return new User();
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
	}

	POSTUser(body: User){
		try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.post(`${this._url}`, JSON.stringify(body.dto()),{ headers: httpHeaders }).pipe(
                        map((res:any) => {
                            return res;
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
	}

	PUTUser(body: User, user_uuid:string) {
		try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.put(`${this._url}/${user_uuid}`, JSON.stringify(body.dto()),{ headers: httpHeaders }).pipe(
                        map((res:any) => {
                            return res;
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
	}

	DELETEUser(user_uuid:string) {
		try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.delete(`${this._url}/${user_uuid}`,{ headers: httpHeaders }).pipe(
                        map((res:any) => {
                            return res;
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
	}
}
